import React, { useMemo } from 'react'
import Tree, { TreeProps, TreeNode, TreeNodeProps } from '@ui-components/rc-tree'
import { Data } from './types'

import TriStateCheckbox from 'live/components/ui/TriStateCheckbox'
import Icon from '@ui-components/icon'
import { Container } from './styled'

interface Props extends TreeProps {
    data?: Data[]
    filterTerm?: string
    filterData?: (data: Data[], filterTerm: string) => Data[]
    renderNodes?: (nodes: Data[]) => React.FC<TreeNodeProps>[]
}

const TreeCheckbox: React.FC<Props> = ({ renderNodes, data = [], filterTerm, filterData, ...treeProps }) => {
    const filteredData = useMemo(() => (filterData && filterTerm ? filterData(data, filterTerm) : data), [
        data,
        filterTerm
    ])
    const renderTreeNodes = (nodes: Data[], level = 0) => {
        return nodes.map(({ id, children, name, visible }) => {
            const shouldRender = visible === undefined || visible
            return (
                <TreeNode
                    key={id}
                    title={name}
                    style={{ paddingLeft: level * 14, display: shouldRender ? 'block' : 'none' }}
                    switcherIcon={({ expanded }) => (
                        <Icon
                            type={'caret-right'}
                            style={{ fontWeight: 600, marginRight: 7, cursor: 'pointer', visibility: `${children ? 'initial' : 'hidden'}` }}
                            rotate={expanded ? 90 : 0}
                        />
                    )}
                    renderCheckbox={({ onCheck, checked, disableCheckbox, disabled, halfChecked }) => {
                        return (
                            <div onClick={onCheck} style={{ display: 'inline-flex' }}>
                                <TriStateCheckbox
                                    type="checkbox"
                                    checked={checked}
                                    disabled={disableCheckbox || disabled}
                                    indeterminate={halfChecked}
                                />
                            </div>
                        )
                    }}
                >
                    {children && renderTreeNodes(children, level + 1)}
                </TreeNode>
            )
        })
    }
    
    return (
        <Container>
            <Tree {...treeProps}>{renderNodes ? renderNodes(filteredData) : renderTreeNodes(filteredData)}</Tree>
        </Container>
    )
}

export default TreeCheckbox
